module.exports = __webpack_public_path__ + "static/img/7.079639a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/7.png
// module id = ERFB
// module chunks = 0